/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserStatisticsPageViewsResponse } from '../../models/user-statistics-page-views-response';

export interface PageViewsByGaId$Params {
  GAId: string;
}

export function pageViewsByGaId(http: HttpClient, rootUrl: string, params: PageViewsByGaId$Params, context?: HttpContext): Observable<StrictHttpResponse<UserStatisticsPageViewsResponse>> {
  const rb = new RequestBuilder(rootUrl, pageViewsByGaId.PATH, 'get');
  if (params) {
    rb.path('GAId', params.GAId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserStatisticsPageViewsResponse>;
    })
  );
}

pageViewsByGaId.PATH = '/rest/user/pageviews-by-gaid/{GAId}';
